import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/raptor/program/clusterdev/desh-web-editor/app/(routes)/(index)/GoogleLibs.tsx");
;
import(/* webpackMode: "eager" */ "/home/raptor/program/clusterdev/desh-web-editor/node_modules/next/dist/client/script.js");
